import React, {
  useState, useEffect, useCallback, useMemo,
} from 'react';
import * as Styles from './SitesWizardHandler.styles';
import useLocale from '@/hooks/useLocale';
import { ChooseDomainStep } from './components/ChooseDomainStep';
import { OtherToolsSuccess } from './components/OtherToolsSuccess';
import { GenericSuccess } from '@/components/FullWidthTemplate/GenericSuccess';
import { SiteBuilderSuccess } from '@/components/FullWidthTemplate/SiteBuilderSuccess';
import { WordPressInstall } from './components/WordPressInstall';
import { ChooseSiteOption } from './components/ChooseSiteOption';
import {
  FLOWS, multiDomainsPlansIds, singleDomainsPlansIds, STEPS,
} from './SitesWizardHandler.enum';
import {
  IconAiStar,
  IconArrow, IconButton, IconExternalLink, IconLoading,
  IconPicture, IconGoogleBusiness,
} from 'gatorcomponents';
import { CART_URL, COUNTRY } from '@/config';
import { AGENT_FACTORY_URL_EDIT } from '@/config/urls/agentFactoryUrls';
import DOMPurify from 'dompurify';
import { useDispatch, useSelector } from 'react-redux';
import {
  domainsActions, onboardingActions, sitesActions, agentsFactoryActions,
} from '@/redux/modules';
import {
  ATIVACAO_ALLOW_CHOOSE_TEMP_OWNED_DOMAIN_REENTRADA,
  ATIVACAO_CHOOSE_MIGRATION_STEP,
  ATIVACAO_SITES_ONBOARDING, ATIVACAO_UPDATE_ONBOARDING_FLOW_EVERY_STEP_CHANGE,
  PORTFOLIO_ONBOARDING_HG_BUILDER_PREVIEW,
  PORTFOLIO_AGENT_FACTORY_NEW_ONBOARDING_WHATSAPP,
} from '@/config/GrowthBook/constants';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import {
  Redirect, useHistory, useParams,
} from 'react-router';
import { getURLCpanel } from '@/config/urls/cpanelUrls';
import { useBlockedWindowModal } from '@/hooks/useBlockedWindowModal';
import { clearOnboarding } from '@/redux/actions/summary';
import HgLogoV2 from '@/media/logo/HgLogoV2';
import WpIaScreen from '@/media/onboarding/wp-ai-success-br.webp';
import WpNormalScreen from '@/media/onboarding/wp-normal-success.webp';
import siteBuilderSuccessBr from '@/media/onboarding/sitebuilder/sitebuilder_success_br.png';
import siteBuilderSuccessEs from '@/media/onboarding/sitebuilder/sitebuilder_success_es.png';
import { isBRServer } from '@/utils/Validators/validation';
import { SiteAlreadyExists } from './components/SiteAlreadyExists';
import { UpgradePlanStep } from './components/UpgradePlanStep';
import { removeProductDetail } from '@/redux/actions/productDetail';
import { onboardingAnalytics } from '@/analytics/onboarding';
import { SelectPlanListStep } from './components/SelectPlanListStep';
import { useOnboardingActions } from '@/hooks/onboarding/useOnboardingActions';
import { DomainNotRegistered } from './components/DomainNotRegistered';
import { ExternalDomain } from '@/components/OnboardingHandlerComponents/ExternalDomain';
import OtherToolsScreen from '@/media/onboarding/other-tools.webp';
import { WordpressMigration } from '../../WordpressMigration';
import { ChooseWpMigrationStep } from '@/components/OnboardingHandlerComponents/ChooseWpMigrationStep';
import { AiBuilderMyBusiness } from './components/AiBuilderMyBusiness';
import { AiBuilderCreateSite } from './components/AiBuilderCreateSite';
import { SiteBuilderV2 } from '@/components/OnboardingHandlerComponents/SiteBuilderV2';
import { AiBuilderWithTemplate } from '@/components/OnboardingHandlerComponents/AiBuilderWithTemplate';
import { AgentWelcome } from '@/components/OnboardingHandlerComponents/AgentWelcome';
import { siteBuilderAiAnalytics } from '@/analytics/siteBuilderAi';
import { CREATE_SITE_TABS } from '@/components/OnboardingHandlerComponents/AiBuilderCreateSite/AiBuilderCreateSite.enum';
import { ExitConfirmModal } from './components/ExitConfirmModal';
import { useResize } from '@/hooks/useResize';
import { ConfirmModal } from '@/components/OnboardingHandlerComponents/ConfirmModal';
import { NewAiHeaderButton } from '@/components/Layout/Menu/HeaderV2/components/NewAiHeaderButton';
import { POPUP_BLOCKED_ORIGIN } from '@/hooks/useBlockedWindowModal/useBlockedWindowModal.enum';
import { SiteBuilderAgentSuccess } from '@/components/FullWidthTemplate/SiteBuilderAgentSuccess';
import { AiBuilderCreateSiteAgent } from '@/components/OnboardingHandlerComponents/AiBuilderCreateSiteAgent';
import { SiteBuilderPreview } from '@/components/OnboardingHandlerComponents/SiteBuilderPreview';

let updateStepsTimout = null;
const SitesWizardHandler = () => {
  const params = useParams();
  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 600;
  const [showLogo, setShowLogo] = useState(true);
  const [aiButtonFocused, setAiButtonFocused] = useState(false);

  const searchParams = new URLSearchParams(window.location.search || '');
  const isAgentAvailableParam = searchParams.get('isAgentAvailable') === 'true';

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setShowLogo(scrollPosition < 5);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const withWpMigration = useFeatureIsOn(ATIVACAO_CHOOSE_MIGRATION_STEP);
  const initialStep = withWpMigration ? STEPS.CHOOSE_WP_MIGRATION : STEPS.CHOOSE_SITE_OPTION;

  const [blockedWindowUrl, setBlockedWindowUrl] = useState('');
  const [sitebuilderLoading, setSitebuilderLoading] = useState(false);
  const [loadingCpanelSSOProduct, setLoadingCpanelSSOProduct] = useState(null);
  const [userAvailablePlans, setUserAvailablePlans] = useState([]);
  const [selectedObject, setSelectedObject] = useState(null);
  const [executeAfterTempDomainCreation, setExecuteAfterTempDomainCreation] = useState(null);
  const [needRequestChangeDomain, setNeedRequestChangeDomain] = useState({ bool: false });
  const [handlingDomainAvailability, setHandlingDomainAvailability] = useState(false);
  const [selectedOtherOption, setSelectedOtherOption] = useState(null);
  const [displayNormalModeModal, setDisplayNormalModeModal] = useState(false);
  const [displayAdvancedModeModal, setDisplayAdvancedModeModal] = useState(false);
  const [projectData, setProjectData] = useState(null);
  const [aiBuilderAgentData, setAiBuilderAgentData] = useState({
    name: '',
    segment: '',
    description: '',
    phone: '',
    email: '',
    toneOfVoice: '',
  });
  const [typeProject, setTypeProject] = useState(null);

  const sitesReducer = useSelector(state => state.sites);
  const { wordpressLoading, sitebuilder: aiBuilderState } = useSelector(state => state.sites);
  const domainsReducer = useSelector(state => state.newDomains);
  const { changeDomain } = useSelector(state => state.newDomains);
  const { wizard, sitebuilder: onboardingBuilderState } = useSelector(state => state.newOnboarding);
  const { visibleAiChat, minimizedChat } = useSelector(state => state.merlin);
  const {
    email: userEmail,
    name: userName,
    country: userCountry,
  } = useSelector(state => state.summary);
  const { migrationData } = useSelector(state => state.merlin);
  const { currentAgentId } = useSelector(state => state.agentsFactory);
  const { projectUid, loading: createPreviewLoading, status: createPreviewStatus } = useSelector(state => state.sites.sitebuilder.createPreview);

  const history = useHistory();
  const dispatch = useDispatch();
  const { renderBlockedWindowModal, setPopupBlockedModalOnCookie } = useBlockedWindowModal();

  const {
    onboarding: onboardingLocale,
    routes: routesLocale,
    changeDomain: changeDomainLocale,
  } = useLocale();

  const sitesOnboardingEnabled = useFeatureIsOn(ATIVACAO_SITES_ONBOARDING);
  const allowTempDomainCreation = useFeatureIsOn(ATIVACAO_ALLOW_CHOOSE_TEMP_OWNED_DOMAIN_REENTRADA);
  const updateFlowEveryStepChange = useFeatureIsOn(ATIVACAO_UPDATE_ONBOARDING_FLOW_EVERY_STEP_CHANGE);
  const onboardingHgBuilderPreview = useFeatureIsOn(PORTFOLIO_ONBOARDING_HG_BUILDER_PREVIEW);
  const agentWhatsAppEnabled = useFeatureIsOn(PORTFOLIO_AGENT_FACTORY_NEW_ONBOARDING_WHATSAPP);

  const {
    requestData,
    getAddons,
    cleanUp,
    requestDomainsPage,
    shouldRequestNewDomainsPage,
    getDomainsNextPage,
    resetAddDomainToPlan,
    showAutoCompleteDomain,
    setShowAutoCompleteDomain,
    requestChangeDomain,
    shouldUseCreateTempDomainAsDefault,
    usingTempDomain,
    setUsingTempDomain,
    currentFlow,
    setCurrentFlow,
    isWordPressAI,
    addDomainToPlan,
    currentHosting,
    setCurrentHosting,
    configureDns,
    isInternalDomain,
    otherToolsRedirect,
    setOtherToolsRedirect,
    userDomainsList,
    setDefaultDomains,
    wordpressInstallationIsFinished,
    autoCompleteDomain,
    autoCompleteOptions,
    handleVerifyIfSiteExist,
    checkDomainAvailabilty,
    currentStep,
    setCurrentStep,
    selectedDomain,
    setSelectedDomain,
    provisioningSitebuilderOnHosting,
    requestCreateSiteWithAiBuilder,
    requestCreatePreviewWithAiBuilder,
    requestSyncPreviewWithAiBuilder,
    getBuilderTemplateCategories,
    getBuilderTemplates,
    getBuilderAddonIdByHostingId,
    redirectSuccessPageAiBuilder,
    redirectPreviewPage,
    displayExitConfirmModal,
    onCloseWizard,
    setDisplayExitConfirmModal,
    dispatchClmEvent,
  } = useOnboardingActions({
    allowTempDomainCreation,
    currentHostingInitialState: {},
    initialStep,
    domain: params && params.domain,
    isAgentAvailableParam,
  });
  const initialStepStyle = currentStep === STEPS.CHOOSE_SITE_OPTION;

  const isLoading = (sitesReducer.loading || domainsReducer.loading || usingTempDomain === undefined) && currentStep === initialStep;

  const initialStepGaTag = useCallback(() => {
    onboardingAnalytics.initialStep.accessOnboarding();
  }, []);

  useEffect(() => {
    initialStepGaTag();
  }, [initialStepGaTag]);

  const chooseDomainStep = STEPS.SELECT_DOMAIN;

  useEffect(() => {
    shouldUseCreateTempDomainAsDefault();
  }, [shouldUseCreateTempDomainAsDefault]);

  useEffect(() => {
    requestData();
  }, [requestData]);

  useEffect(() => {
    requestDomainsPage();
  }, [requestDomainsPage]);

  useEffect(() => {
    shouldRequestNewDomainsPage();
  }, [shouldRequestNewDomainsPage]);

  const handleGoBack = useCallback(() => {
    if (currentStep === STEPS.CHOOSE_WP_MIGRATION) {
      history.goBack();
      return;
    }

    if (currentFlow === FLOWS.WORDPRESS_MIGRATION || withWpMigration) {
      setCurrentStep(STEPS.CHOOSE_WP_MIGRATION);
      shouldUseCreateTempDomainAsDefault();
      return;
    }

    history.goBack();
  }, [
    currentFlow,
    currentStep,
    history,
    setCurrentStep,
    withWpMigration,
    shouldUseCreateTempDomainAsDefault,
  ]);

  const nextStepRule = useMemo(() => ({
    [FLOWS.WORDPRESS]: STEPS.WORDPRESS_INSTALL,
    [FLOWS.WORDPRESS_IA]: STEPS.WORDPRESS_INSTALL,
    [FLOWS.SITE_BUILDER_V2]: isAgentAvailableParam ? STEPS.AGENT_WELCOME : STEPS.SITE_BUILDER_V2,
    [FLOWS.SITE_BUILDER]: isInternalDomain ? STEPS.SUCCESS : STEPS.EXTERNAL_DOMAIN,
    [FLOWS.OTHER_TOOLS]: STEPS.SUCCESS,
    [FLOWS.AGENT_FACTORY]: STEPS.SUCCESS,
    [FLOWS.WORDPRESS_MIGRATION]: STEPS.WORDPRESS_MIGRATION,
  }), [isInternalDomain, isAgentAvailableParam]);

  const continueAfterCreatingTempDomain = useCallback(() => {
    if (
      usingTempDomain
      && domainsReducer.createdTemporaryDomain
      && !domainsReducer.loadingTemporaryDomainCreation
      && [
        STEPS.SELECT_DOMAIN,
        STEPS.SELECT_PLAN_LIST,
        STEPS.BUY_DOMAIN,
        STEPS.WORDPRESS_INSTALL,
      ].includes(currentStep)
      && !sitesReducer.loading
    ) {
      setCurrentHosting({
        ...currentHosting,
        domain: domainsReducer.createdTemporaryDomain,
      });

      if (executeAfterTempDomainCreation) {
        executeAfterTempDomainCreation(domainsReducer.createdTemporaryDomain);
      }

      if (!executeAfterTempDomainCreation) {
        addDomainToPlan({
          domain: domainsReducer.createdTemporaryDomain,
          hostingId: currentHosting.hosting_id,
          selectedObject: currentHosting,
        });
      }

      dispatch(domainsActions.temporaryDomains.creation.set(null));
    }
  }, [
    domainsReducer.createdTemporaryDomain,
    domainsReducer.loadingTemporaryDomainCreation,
    executeAfterTempDomainCreation,
    currentHosting,
    dispatch,
    addDomainToPlan,
    sitesReducer.loading,
    currentStep,
    usingTempDomain,
    setCurrentHosting,
  ]);

  const updateToNextStep = useCallback(() => {
    if (
      usingTempDomain
      && sitesReducer.domainLinkedToPlan
      && [
        STEPS.SELECT_DOMAIN,
        STEPS.SELECT_PLAN_LIST,
        STEPS.BUY_DOMAIN,
      ].includes(currentStep)
    ) {
      setCurrentStep(nextStepRule[currentFlow]);
      resetAddDomainToPlan({ domainLinkedToPlan: false });
    }
  }, [
    currentFlow,
    nextStepRule,
    currentStep,
    sitesReducer.domainLinkedToPlan,
    resetAddDomainToPlan,
    usingTempDomain,
    setCurrentStep,
  ]);

  useEffect(() => {
    updateToNextStep();
  }, [updateToNextStep]);

  useEffect(() => {
    continueAfterCreatingTempDomain();
  }, [continueAfterCreatingTempDomain]);

  const resetStatusOnLeave = useCallback(() => {
    cleanUp();
  }, [cleanUp]);

  useEffect(() => () => {
    resetStatusOnLeave();
  }, [resetStatusOnLeave]);

  const noFilesToBeExcluded = !sitesReducer.currentlyInstallInfo.siteId
    && !sitesReducer.needToExcludeDefaultFiles
    && sitesReducer.siteExistVerifyFinished;

  const readyToCreateSite = (noFilesToBeExcluded && !sitesReducer.loadingUninstall) || sitesReducer.uninstallCompleted;

  const redirectToSiteAlreadyCreatedStep = useCallback(() => {
    const canRedirectToSiteAlreadyCreated = sitesReducer.currentlyInstallInfo.siteId
      || !!sitesReducer.currentlyInstallInfo.showOverwriteModal;

    if (canRedirectToSiteAlreadyCreated && !sitesReducer.loadingUninstall) {
      return setCurrentStep(STEPS.SITE_ALREADY_EXISTS);
    }

    if (sitesReducer.needToExcludeDefaultFiles && !sitesReducer.uninstallCompleted && !sitesReducer.loadingUninstall) {
      return dispatch(sitesActions.uninstallSite.request({
        domain: currentHosting.domain,
        hostingId: currentHosting.hosting_id,
        domainId: selectedObject.id,
        domainHasPlan: true,
        needToExcludeDefaultFiles: true,
      }));
    }

    if (readyToCreateSite) {
      dispatch(sitesActions.verifyIfSiteExist.reset());
      return setCurrentStep(nextStepRule[currentFlow]);
    }
  }, [
    currentHosting,
    selectedObject,
    currentFlow,
    nextStepRule,
    sitesReducer.currentlyInstallInfo,
    sitesReducer.needToExcludeDefaultFiles,
    sitesReducer.uninstallCompleted,
    sitesReducer.loadingUninstall,
    readyToCreateSite,
    dispatch,
    setCurrentStep,
  ]);

  useEffect(() => {
    redirectToSiteAlreadyCreatedStep();
  }, [
    redirectToSiteAlreadyCreatedStep,
  ]);

  useEffect(() => {
    if (currentFlow === FLOWS.SITE_BUILDER) {
      getAddons({ currentHosting });
    }
  }, [getAddons, currentHosting, currentFlow]);

  useEffect(() => {
    getDomainsNextPage();
  }, [getDomainsNextPage]);

  useEffect(() => {
    setDefaultDomains({
      setSelectedDomain,
      paramsDomain: params.domain,
    });
  }, [setDefaultDomains, setSelectedDomain, params]);

  const updateOnboardingSteps = useCallback((forced) => {
    const defaultFlow = () => {
      if (domainsReducer.changeDomain.loading) {
        return;
      }

      if (updateFlowEveryStepChange && (wizard.started)) {
        const stepAsKebabCase = currentStep.replace(/_/g, '-').toLowerCase();

        const builderRules = {
          [FLOWS.WORDPRESS]: 'wordpress',
          [FLOWS.WORDPRESS_IA]: 'wordpress-ia',
          [FLOWS.SITE_BUILDER]: 'sitebuilder',
          [FLOWS.SITE_BUILDER_V2]: 'brizy',
          [FLOWS.AGENT_FACTORY]: 'brizy',
          [FLOWS.OTHER_TOOLS]: 'other',
        };

        const isFinished = ((currentStep === STEPS.SUCCESS || currentStep === STEPS.EXTERNAL_DOMAIN) && currentFlow !== FLOWS.OTHER_TOOLS)
          || forced;

        if ((isFinished)) {
          sessionStorage.setItem('onboardingFinished', true);
        }

        const builder = (currentFlow === FLOWS.OTHER_TOOLS && selectedOtherOption)
          ? `${builderRules[currentFlow]}-${selectedOtherOption}`
          : builderRules[currentFlow];

        if (currentFlow !== FLOWS.WORDPRESS_MIGRATION && !!builder) {
          dispatch(onboardingActions.wizard.update.request({
            wizardId: wizard.id,
            hostingId: currentHosting && currentHosting.hosting_id,
            domain: currentHosting && currentHosting.domain,
            origin: 'wizard',
            builder,
            step: stepAsKebabCase,
            finished: isFinished,
          }));
        }
      }
    };

    if (forced) {
      defaultFlow();
    }

    if (!forced) {
      clearTimeout(updateStepsTimout);
      updateStepsTimout = setTimeout(() => {
        defaultFlow();
      }, 100);
    }
  }, [
    currentFlow,
    currentHosting,
    dispatch,
    wizard.started,
    currentStep,
    updateFlowEveryStepChange,
    selectedOtherOption,
    wizard.id,
    domainsReducer.changeDomain.loading,
  ]);


  useEffect(() => {
    updateOnboardingSteps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep, currentHosting, wizard.started, selectedOtherOption]);

  useEffect(() => {
    const domain = currentHosting ? currentHosting.domain : selectedObject.domain;
    wordpressInstallationIsFinished({ domain });
  }, [wordpressInstallationIsFinished, setCurrentStep, currentStep, currentHosting, selectedObject]);

  const handleCloseBlockedWindowModal = () => {
    setBlockedWindowUrl('');
  };

  const handleRegisterHostingOnboarding = useCallback(() => {
    const origin = 'wizard';
    const canRequestRegister = true;
    const startRegister = wizard.started;

    if (!startRegister && canRequestRegister) {
      const builderInfo = {
        domain: currentHosting && currentHosting.domain,
        origin,
      };

      dispatch(onboardingActions[origin].register.request(builderInfo));
    }
  }, [
    currentHosting,
    dispatch,
    wizard.started,
  ]);

  const getChooseSiteOptionProps = useCallback(() => {
    const options = [
      {
        ...onboardingLocale.chooseSiteOption.options[0],
        cta: {
          ...onboardingLocale.chooseSiteOption.options[0].cta,
          action: () => {
            handleRegisterHostingOnboarding();
            setCurrentFlow(FLOWS.SITE_BUILDER_V2);
            setCurrentStep(STEPS.SELECT_DOMAIN);
            dispatchClmEvent({ action: 'click-create-site', finished: false });
            onboardingAnalytics.sitebuilder.select();
          },
        },
      },
      {
        ...onboardingLocale.chooseSiteOption.options[1],
        cta: {
          ...onboardingLocale.chooseSiteOption.options[1].cta,
          action: () => {
            handleRegisterHostingOnboarding();
            setCurrentFlow(FLOWS.WORDPRESS_IA);
            setCurrentStep(STEPS.SELECT_DOMAIN);
            onboardingAnalytics.wordpressIa.select();

            dispatch(onboardingActions.onboarding.register.request({
              hostingId: currentHosting.hosting_id,
              domain: currentHosting.domain,
              origin: 'wizard',
            }));
            dispatchClmEvent({ action: 'click-migrate-wordpress', finished: false });
          },
        },
        ctaFooter: {
          ...onboardingLocale.chooseSiteOption.options[1].ctaFooter,
          action: () => {
            setDisplayNormalModeModal(true);
            onboardingAnalytics.wordpressDefault.select();
          },
        },
      },
    ];

    return {
      title: onboardingLocale.chooseSiteOption.title,
      options,
      haveExperienceLabel: onboardingLocale.chooseSiteOption.haveExperienceLabel,
      ctaAdvancedMode: {
        ...onboardingLocale.chooseSiteOption.ctaAdvancedMode,
        action: () => {
          setDisplayAdvancedModeModal(true);
          onboardingAnalytics.otherTools.select();
        },
      },
    };
  }, [
    dispatch,
    currentHosting,
    onboardingLocale,
    setCurrentStep,
    setCurrentFlow,
    setDisplayAdvancedModeModal,
    handleRegisterHostingOnboarding,
    dispatchClmEvent,
  ]);

  const redirectToPortal = useCallback(() => {
    dispatch(clearOnboarding());

    history.push(routesLocale.home);
  }, [dispatch, history, routesLocale]);

  const handleCloseOnBoarding = useCallback(() => {
    const hgBuilderSteps = [STEPS.IA_BUILDER_CREATE_SITE, STEPS.IA_BUILDER_WITH_TEMPLATE, STEPS.IA_BUILDER_MY_BUSINESS];

    if (hgBuilderSteps.includes(currentStep)) {
      setDisplayExitConfirmModal(true);
      return;
    }

    redirectToPortal();
  }, [redirectToPortal, currentStep, setDisplayExitConfirmModal]);

  useEffect(() => {
    handleVerifyIfSiteExist();
  }, [handleVerifyIfSiteExist]);

  const handleCreateTempDomain = useCallback(({ hostingId }) => {
    const userMultiDomainsPlans = userDomainsList.filter(item => multiDomainsPlansIds.includes(item.package_id) && item.product_name);

    if (!hostingId) {
      if (userMultiDomainsPlans.length > 1) {
        const userSingleDomainsPlans = userDomainsList.filter(item => singleDomainsPlansIds.includes(item.package_id));

        const singleDomainPlansWithDomain = userSingleDomainsPlans[0]
          ? domainsReducer.temporaryDomains.filter(item => item.domain === userSingleDomainsPlans[0].domain && item.product_name)
          : [];

        const avaiablePlansList = [
          ...singleDomainPlansWithDomain,
          ...userMultiDomainsPlans,
        ];

        setUserAvailablePlans(avaiablePlansList);
        setCurrentStep(STEPS.SELECT_PLAN_LIST);
        return;
      }

      if (userMultiDomainsPlans.length === 1) {
        const availablePlan = userMultiDomainsPlans[0];
        delete availablePlan.domain;
        setCurrentHosting({
          ...availablePlan,
          hosting_id: availablePlan.hosting_id,
        });

        dispatch(domainsActions.temporaryDomains.creation.request({ hostingId: availablePlan.hosting_id }));
        return;
      }
    }

    if (hostingId) {
      if (hostingId !== currentHosting.hosting_id) {
        setCurrentHosting({
          ...currentHosting,
          hosting_id: hostingId,
        });
      }

      dispatch(domainsActions.temporaryDomains.creation.request({ hostingId }));
    }
  }, [
    dispatch,
    userDomainsList,
    currentHosting,
    domainsReducer.temporaryDomains,
    setCurrentHosting,
    setCurrentStep,
  ]);

  const handleDomainAvailability = useCallback(() => {
    if (
      sitesReducer.domainAvailability !== undefined
      && !sitesReducer.loading
      && !sitesReducer.loadingDomainValidation
      && ((selectedObject
        && selectedObject.selectedDomain) || needRequestChangeDomain.newDomain)
      && currentStep === STEPS.SELECT_DOMAIN
      && !handlingDomainAvailability
    ) {
      setHandlingDomainAvailability(true);
      const domain = (selectedObject && selectedObject.selectedDomain) || (needRequestChangeDomain.newDomain);
      const domainIsAvailable = sitesReducer.domainAvailability === true;

      if ((domain) && !domainIsAvailable) {
        if (needRequestChangeDomain.bool && needRequestChangeDomain.newDomain) {
          requestChangeDomain(needRequestChangeDomain.newDomain);
          setNeedRequestChangeDomain({
            ...needRequestChangeDomain,
            bool: false,
          });
        }

        if (!needRequestChangeDomain.newDomain) {
          dispatch(sitesActions.verifyIfSiteExist.reset());

          const userSingleDomainsPlans = userDomainsList.filter(item => singleDomainsPlansIds.includes(item.package_id));
          const singleDomainPlansWithDomain = userSingleDomainsPlans[0]
            ? domainsReducer.temporaryDomains.filter(item => item.domain === userSingleDomainsPlans[0].domain && item.product_name)
            : [];
          const singleDomainPlansWithSelectedDomain = userSingleDomainsPlans.filter(item => item.domain === selectedObject.selectedDomain);
          const haveSingleDomainPlans = (userSingleDomainsPlans.length > 0 && (!!singleDomainPlansWithDomain.length || !!singleDomainPlansWithSelectedDomain.length));

          const userMultiDomainsPlans = userDomainsList.filter(item => multiDomainsPlansIds.includes(item.package_id) && item.product_name);
          const haveMultiDomainPlans = userMultiDomainsPlans.length > 0;
          const havePlans = haveMultiDomainPlans || haveSingleDomainPlans;
          const isNewTypedDomain = !selectedObject.hosting_id;

          if (!havePlans) {
            setSelectedObject(userSingleDomainsPlans[0]);
            setCurrentStep(STEPS.BUY_PLAN);
          }

          if (havePlans) {
            const haveMultiplePlan = (
              userMultiDomainsPlans.length
              + singleDomainPlansWithDomain.length
            ) > 1;

            const avaiablePlansList = [
              ...singleDomainPlansWithDomain,
              ...userMultiDomainsPlans,
              ...singleDomainPlansWithSelectedDomain,
            ];

            if (haveMultiplePlan) {
              setUserAvailablePlans(avaiablePlansList);
              setCurrentStep(STEPS.SELECT_PLAN_LIST);
            }

            if (!haveMultiplePlan) {
              if (singleDomainPlansWithSelectedDomain.length === 1) {
                const availablePlan = singleDomainPlansWithSelectedDomain[0];
                setCurrentHosting({
                  ...currentHosting,
                  hosting_id: selectedObject.hosting_id,
                  domain: selectedObject.selectedDomain,
                });
                configureDns({
                  domain: selectedObject.selectedDomain,
                  domainId: selectedObject.domain_id,
                  hostingId: availablePlan.hosting_id,
                });

                if (usingTempDomain) {
                  handleCreateTempDomain({ hostingId: selectedObject.hosting_id });
                  setCurrentHosting({
                    ...currentHosting,
                    hosting_id: selectedObject.hosting_id,
                  });
                }

                if (!usingTempDomain && !isNewTypedDomain) {
                  dispatch(sitesActions.verifyIfSiteExist.request({ domain: selectedObject.domain, hostingId: selectedObject.hosting_id }));
                }
              }

              if (userMultiDomainsPlans.length === 1 && isNewTypedDomain) {
                const availablePlan = userMultiDomainsPlans[0];

                if (usingTempDomain) {
                  setCurrentHosting({
                    ...availablePlan,
                    hosting_id: availablePlan.hosting_id,
                  });
                }

                if (!usingTempDomain) {
                  setCurrentHosting({
                    ...availablePlan,
                    domain: selectedObject.selectedDomain,
                    hosting_id: availablePlan.hosting_id,
                  });
                  configureDns({
                    domain: selectedObject.selectedDomain,
                    domainId: selectedObject.domain_id,
                    hostingId: availablePlan.hosting_id,
                  });
                }

                const domainInUse = selectedObject.selectedDomain;
                const hostingId = availablePlan.hosting_id;
                const itemByHostingIdState = userDomainsList.find(item => (item.hosting_id === hostingId) && item.cpanel_domains);
                const cpanelDomains = (itemByHostingIdState && itemByHostingIdState.cpanel_domains) || null;
                const alreadyExistsCpanel = cpanelDomains && cpanelDomains.some(item => item.domain === domainInUse);

                if (usingTempDomain) {
                  handleCreateTempDomain({ hostingId: availablePlan.hosting_id });
                }

                if (!usingTempDomain) {
                  if (!alreadyExistsCpanel) {
                    addDomainToPlan({
                      domain: selectedObject.selectedDomain,
                      hostingId: availablePlan.hosting_id,
                      selectedObject: availablePlan,
                    });
                  }

                  if (alreadyExistsCpanel) {
                    dispatch(sitesActions.verifyIfSiteExist.request({
                      domain: selectedObject.selectedDomain || (domainsReducer.createdTemporaryDomain),
                      hostingId: availablePlan.hosting_id,
                    }));
                  }
                }
              }

              if (userMultiDomainsPlans.length === 1 && !isNewTypedDomain) {
                if (usingTempDomain) {
                  handleCreateTempDomain({ hostingId: selectedObject.hosting_id });
                  setCurrentHosting({
                    hosting_id: selectedObject.hosting_id,
                  });
                }

                if (!usingTempDomain) {
                  setCurrentHosting({
                    domain: selectedObject.selectedDomain,
                    hosting_id: selectedObject.hosting_id,
                  });

                  configureDns({
                    domain: selectedObject.selectedDomain,
                    domainId: selectedObject.domain_id,
                    hostingId: selectedObject.hosting_id,
                  });

                  dispatch(sitesActions.verifyIfSiteExist.request({ domain: selectedObject.domain, hostingId: selectedObject.hosting_id }));
                }
              }
            }
          }
        }
      }

      if (domain && domainIsAvailable && !usingTempDomain) {
        setCurrentStep(STEPS.BUY_DOMAIN);
      }
    }
  }, [
    domainsReducer.createdTemporaryDomain,
    configureDns,
    sitesReducer.domainAvailability,
    userDomainsList,
    domainsReducer.temporaryDomains,
    selectedObject,
    dispatch,
    currentHosting,
    addDomainToPlan,
    sitesReducer.loadingDomainValidation,
    usingTempDomain,
    handleCreateTempDomain,
    sitesReducer.loading,
    needRequestChangeDomain,
    requestChangeDomain,
    currentStep,
    handlingDomainAvailability,
    setHandlingDomainAvailability,
    setCurrentHosting,
    setCurrentStep,
  ]);

  useEffect(() => {
    handleDomainAvailability();
  }, [handleDomainAvailability]);

  const getChooseDomainProps = useCallback(() => {
    const temporaryDomain = currentHosting.domain;
    const changeDomainLoading = changeDomain.loading;

    const backToInitialStep = () => {
      const analyticsRules = {
        [FLOWS.WORDPRESS_IA]: onboardingAnalytics.wordpressIa.goBackStep1,
        [FLOWS.WORDPRESS]: onboardingAnalytics.wordpressDefault.goBackStep1,
        [FLOWS.SITE_BUILDER]: onboardingAnalytics.sitebuilder.goBackStep1,
        [FLOWS.OTHER_TOOLS]: onboardingAnalytics.otherTools.goBackStep1,
      };

      const analyticGoBackCta = analyticsRules[currentFlow];
      analyticGoBackCta && analyticGoBackCta();

      setCurrentStep(STEPS.CHOOSE_SITE_OPTION);
      shouldUseCreateTempDomainAsDefault();
    };

    const backToChooseWpMigration = () => {
      setCurrentStep(STEPS.CHOOSE_WP_MIGRATION);
      shouldUseCreateTempDomainAsDefault();
    };

    const handleContinueInsideWizard = (object) => {
      setHandlingDomainAvailability(false);
      setNeedRequestChangeDomain({ bool: false });
      setSelectedObject(object);
      onboardingAnalytics.chooseDomain.selectDomainContinue();

      if (usingTempDomain) {
        handleCreateTempDomain({ hostingId: object.hosting_id });
      }

      if (!usingTempDomain) {
        checkDomainAvailabilty({ domain: object.selectedDomain });
      }
    };

    const hasMultDomainPlans = !!sitesReducer.list.filter(item => multiDomainsPlansIds.includes(item.package_id) && item.product_name && item.status === 'Active').length;

    const handleToggleTempDomain = () => {
      setUsingTempDomain(!usingTempDomain);
    };

    const buttonsProps = {
      leftButton: {
        id: 'choose-domain-left-button',
        testId: 'choose-domain-left-button',
        label: onboardingLocale.goBackButtonLabel,
        onClick: currentFlow === FLOWS.WORDPRESS_MIGRATION ? backToChooseWpMigration : backToInitialStep,
      },
      rightButton: [
        {
          id: 'toggle-temp-domain-button',
          testId: 'toggleTempDomain',
          variant: 'tertiary',
          label: usingTempDomain ? onboardingLocale.useOwnedDomain : onboardingLocale.useTempDomain,
          onClick: handleToggleTempDomain,
        },
        {
          id: 'choose-domain-right-button',
          testId: 'choose-domain-right-button',
          label: onboardingLocale.continueButtonLabel,
          iconRight: !changeDomainLoading && <IconArrow direction="right" />,
          onClick: handleContinueInsideWizard,
        },
      ],
    };

    return {
      locales: onboardingLocale.domainRegistered,
      domainMessageErrorBr: changeDomainLocale.steps.inputDomain.domainMessageErrorBr,
      domainMessageError: changeDomainLocale.steps.inputDomain.domainMessageError,
      currentFlow,
      temporaryDomain,
      changeDomainLoading,
      buttonsProps,
      showAutoCompleteDomain,
      autoCompleteOptions,
      autoCompleteDomain,
      setShowAutoCompleteDomain,
      insideWizard: true,
      userDomainsList,
      selectedDomain,
      setSelectedDomain,
      handleContinueInsideWizard,
      resetAddDomainToPlan,
      loadingSites: sitesReducer.loading,
      loadingVerifyIfSiteExist: sitesReducer.loadingVerifyIfSiteExist,
      loadingUninstall: sitesReducer.loadingUninstall,
      loadingDomainValidation: sitesReducer.loadingDomainValidation,
      usingTempDomain,
      loadingTempDomainCreation: domainsReducer.loadingTempDomainCreation,
      allowTempDomainCreation,
      hasMultDomainPlans,
      FLOWS,
    };
  }, [
    onboardingLocale,
    currentHosting,
    resetAddDomainToPlan,
    changeDomain.loading,
    showAutoCompleteDomain,
    autoCompleteOptions,
    autoCompleteDomain,
    changeDomainLocale,
    userDomainsList,
    selectedDomain,
    sitesReducer.loading,
    sitesReducer.loadingVerifyIfSiteExist,
    sitesReducer.loadingUninstall,
    currentFlow,
    checkDomainAvailabilty,
    sitesReducer.loadingDomainValidation,
    usingTempDomain,
    handleCreateTempDomain,
    domainsReducer.loadingTempDomainCreation,
    allowTempDomainCreation,
    setShowAutoCompleteDomain,
    setUsingTempDomain,
    setCurrentStep,
    setSelectedDomain,
    shouldUseCreateTempDomainAsDefault,
    sitesReducer.list,
  ]);

  const getWordPressInstallProps = useCallback(() => {
    const shouldUseTempDomainCreation = !!(
      allowTempDomainCreation
      && !!sitesReducer.list.filter(item => multiDomainsPlansIds.includes(item.package_id) && item.product_name).length
      && currentFlow !== FLOWS.SITE_BUILDER
    );

    const onSubmit = ({ admin, password }) => {
      const analyticsRules = {
        [FLOWS.WORDPRESS_IA]: onboardingAnalytics.wordpressIa.goForwardStep2,
        [FLOWS.WORDPRESS]: onboardingAnalytics.wordpressDefault.goForwardStep2,
      };

      const goForwardCta = analyticsRules[currentFlow];
      goForwardCta && goForwardCta();
      onboardingAnalytics.wordpressDefault.login();

      const wordpress = {
        domain: (currentHosting && currentHosting.domain) || (domainsReducer.createdTemporaryDomain),
        admin: DOMPurify.sanitize(admin),
        password: DOMPurify.sanitize(password),
        email: userEmail,
        name: userName,
        description: '',
        sets: isWordPressAI ? [`Extendify-${COUNTRY}_admin`] : [],
        external_id: currentHosting.hosting_id,
      };

      dispatch(sitesActions.wordpressInstallation.request({
        wordpress,
        isWondersuiteEnabled: true,
        themeId: 'wp-default',
        userSelectedWondersuiteTrial: false,
        isFastCheckoutAddonEnabled: true,
        userSelectedUseEcommercePlus: false,
      }));
    };

    const leftButtonClick = () => {
      dispatch(sitesActions.verifyIfSiteExist.reset());
      const analyticsRules = {
        [FLOWS.WORDPRESS_IA]: onboardingAnalytics.wordpressIa.goBackStep2,
        [FLOWS.WORDPRESS]: onboardingAnalytics.wordpressDefault.goBackStep2,
      };

      const goBackCta = analyticsRules[currentFlow];
      goBackCta && goBackCta();

      const previousStep = shouldUseTempDomainCreation ? chooseDomainStep : STEPS.CHOOSE_SITE_OPTION;

      setCurrentStep(previousStep);
    };

    const buttonsProps = {
      leftButton: {
        label: onboardingLocale.goBackButtonLabel,
        onClick: leftButtonClick,
        disabled: wordpressLoading,
      },
      rightButton: {
        label: onboardingLocale.continueButtonLabel,
        iconRight: !wordpressLoading && <IconArrow direction="right" />,
      },
    };

    return {
      locales: onboardingLocale.wordPress,
      buttonsProps,
      isWordPressAI,
      currentFlow,
      wordpressLoading,
      onSubmit,
      FLOWS,
    };
  }, [
    domainsReducer.createdTemporaryDomain,
    currentFlow,
    onboardingLocale,
    isWordPressAI,
    userEmail,
    userName,
    wordpressLoading,
    currentHosting,
    chooseDomainStep,
    dispatch,
    allowTempDomainCreation,
    sitesReducer,
    setCurrentStep,
  ]);

  const getSelectPlanListProps = useCallback(() => {
    const handleSameDomain = ({ hostingId, domain }) => {
      dispatch(sitesActions.verifyIfSiteExist.request({
        hostingId,
        domain,
      }));
      configureDns({
        hostingId,
        domain,
      });
    };

    const handleContinue = () => {
      setCurrentStep(nextStepRule[currentFlow]);
    };

    const buttonsProps = {
      leftButton: {
        label: onboardingLocale.goBackButtonLabel,
        onClick: () => {
          setCurrentStep(chooseDomainStep);
          setSelectedObject(null);
        },
      },
      rightButton: {
        label: onboardingLocale.continueButtonLabel,
        iconRight: <IconArrow direction="right" />,
      },
    };

    const { loading, loadingVerifyIfSiteExist, loadingDefaultFilesExclude } = sitesReducer;
    const isButtonLoading = loading || loadingVerifyIfSiteExist || loadingDefaultFilesExclude;

    return {
      locales: onboardingLocale.selectPlanList,
      buttonsProps,
      userAvailablePlans: [...userAvailablePlans].filter(item => !!item.product_name),
      selectedObject,
      addDomainToPlan,
      handleSameDomain,
      handleContinue,
      configureDns,
      setCurrentHosting,
      loadingSites: sitesReducer.loading,
      isButtonLoading,
      userDomainsList,
      readyToCreateSite,
      usingTempDomain,
      handleCreateTempDomain,
      setExecuteAfterTempDomainCreation,
      loadingTempDomainCreation: domainsReducer.loadingTempDomainCreation,
    };
  }, [
    onboardingLocale,
    userAvailablePlans,
    addDomainToPlan,
    currentFlow,
    configureDns,
    setCurrentHosting,
    selectedObject,
    sitesReducer,
    dispatch,
    nextStepRule,
    chooseDomainStep,
    readyToCreateSite,
    userDomainsList,
    usingTempDomain,
    handleCreateTempDomain,
    domainsReducer.loadingTempDomainCreation,
    setCurrentStep,
  ]);

  const getSuccessOtherToolsProps = useCallback(() => {
    const redirectToCpanel = ({ softaculous }) => {
      const forced = true;
      updateOnboardingSteps(forced);

      onboardingAnalytics.otherTools.startNow();

      setLoadingCpanelSSOProduct(true);

      const cpanelUrl = getURLCpanel({
        externalId: currentHosting.hosting_id,
        dispatch,
        setLoadingCpanelSSOProduct: setLoadingCpanelSSOProduct(true),
        setBlockedWindowUrl,
        redirect: redirectToPortal,
      });

      const params = softaculous ? '&app=Softaculous_Home' : '';
      const url = `${cpanelUrl}${params}`;
      window.open(url, '_blank');

      redirectToPortal();
    };

    const redirectToFtp = () => {
      const forced = true;
      updateOnboardingSteps(forced);

      onboardingAnalytics.otherTools.startNow();

      setLoadingCpanelSSOProduct(true);
      dispatch(removeProductDetail());
      history.push(`${routesLocale.products}${routesLocale.productdetail}/${currentHosting.hosting_id}`);
      dispatch(clearOnboarding());
    };

    const handleRedirectToPortal = () => {
      const forced = true;
      updateOnboardingSteps(forced);

      onboardingAnalytics.otherTools.portalButton();
      redirectToPortal();
    };

    const redirectToDomainFeedback = ({ redirectFunc }) => {
      setOtherToolsRedirect(() => redirectFunc);

      if (!isInternalDomain) {
        return setCurrentStep(STEPS.EXTERNAL_DOMAIN);
      }

      if (sitesReducer.domainDnsChanged) {
        return setCurrentStep(STEPS.SUCCESS);
      }
    };

    const onBackToStart = () => {
      setCurrentStep(STEPS.CHOOSE_SITE_OPTION);
    };

    return ({
      title: onboardingLocale.otherTools.title,
      description: onboardingLocale.otherTools.description,
      options: onboardingLocale.otherTools.options,
      redirectToCpanel,
      loadingCpanelSSOProduct,
      redirectToFtp,
      rightButtonLabel: onboardingLocale.otherTools.rightButtonLabel,
      leftButtonLabel: onboardingLocale.otherTools.leftButtonLabel,
      handleRedirectToPortal,
      redirectToDomainFeedback,
      dnsChanged: sitesReducer.domainDnsChanged,
      onBackToStart,
      cleanUp,
      isInternalDomain,
      usingTempDomain,
      setSelectedOtherOption,
    });
  }, [
    usingTempDomain,
    sitesReducer.domainDnsChanged,
    isInternalDomain,
    currentHosting,
    dispatch,
    redirectToPortal,
    setBlockedWindowUrl,
    setLoadingCpanelSSOProduct,
    loadingCpanelSSOProduct,
    history,
    routesLocale,
    onboardingLocale,
    cleanUp,
    setOtherToolsRedirect,
    setCurrentStep,
    setSelectedOtherOption,
    updateOnboardingSteps,
  ]);

  const getSiteAlreadyExistsProps = useCallback(() => {
    const { siteAlreadyExists: siteAlreadyExistsLocale } = onboardingLocale;

    const { needToExcludeDefaultFiles, currentlyInstallInfo } = sitesReducer;

    const uninstallSite = () => {
      dispatch(sitesActions.uninstallSite.request({
        domain: selectedObject.domain || selectedObject.selectedDomain,
        hostingId: currentHosting.hosting_id,
        domainId: currentHosting.domain_id,
        domainHasPlan: true,
        needToExcludeDefaultFiles,
        currentlyInstallInfo,
      }));
    };

    const backToInitialStep = () => {
      setCurrentStep(chooseDomainStep);
      dispatch(sitesActions.verifyIfSiteExist.reset());
    };

    const buttonsProps = {
      leftButton: {
        testId: 'site-already-exists-left-button',
        label: siteAlreadyExistsLocale.goBackButtonLabel,
        onClick: backToInitialStep,
      },
      rightButton: {
        testId: 'site-already-exists-right-button',
        label: siteAlreadyExistsLocale.continueButtonLabel,
        iconRight: <IconArrow direction="right" />,
      },
    };

    return {
      locales: siteAlreadyExistsLocale,
      buttonsProps,
      onContinue: uninstallSite,
      isLoading: sitesReducer.loadingUninstall,
    };
  }, [
    onboardingLocale,
    dispatch,
    sitesReducer,
    selectedObject,
    chooseDomainStep,
    currentHosting.domain_id,
    currentHosting.hosting_id,
    setCurrentStep,
  ]);

  const siteBuilderSso = useCallback(() => {
    setSitebuilderLoading(true);
    dispatch(clearOnboarding()).then(() => {
      const url = `${routesLocale.siteBuilderRedirectAccess}/${currentHosting.domain}/${currentHosting.hosting_id}`;

      window.open(url, '_blank');
      history.push(routesLocale.home);
    });
  }, [
    dispatch,
    currentHosting.domain,
    currentHosting.hosting_id,
    history,
    routesLocale,
  ]);

  const getGenericSuccessProps = useCallback(() => {
    const wordpressSso = () => {
      if (sitesReducer.wordpressSso.ssoUrl) {
        window.open(sitesReducer.wordpressSso.ssoUrl, '_blank');
        redirectToPortal();
        return;
      }

      dispatch(sitesActions.wordpressSso.request({
        hostingId: currentHosting.hosting_id,
        domain: currentHosting.domain,
        siteId: sitesReducer.wordpressSso.siteId,
        callbackFunction: redirectToPortal,
      }));
    };

    const getLocale = () => {
      if (sitesReducer.domainDnsChanged) {
        return onboardingLocale.configuredDnsSuccess;
      }

      const rules = {
        [FLOWS.WORDPRESS]: onboardingLocale.wordPress.wpNormalSuccess(usingTempDomain),
        [FLOWS.WORDPRESS_IA]: onboardingLocale.wordPress.wpIaSuccess(usingTempDomain),
        [FLOWS.SITE_BUILDER]: onboardingLocale.domainRegistered.success,
        [FLOWS.SITE_BUILDER_V2]: onboardingLocale.domainRegistered.success,
        [FLOWS.OTHER_TOOLS]: onboardingLocale.otherTools.success,
      };

      return rules[currentFlow];
    };

    const getImage = () => {
      const rules = {
        [FLOWS.WORDPRESS]: WpNormalScreen,
        [FLOWS.WORDPRESS_IA]: WpIaScreen,
        [FLOWS.SITE_BUILDER]: isBRServer ? siteBuilderSuccessBr : siteBuilderSuccessEs,
        [FLOWS.SITE_BUILDER_V2]: isBRServer ? siteBuilderSuccessBr : siteBuilderSuccessEs,
        [FLOWS.OTHER_TOOLS]: OtherToolsScreen,
      };

      return rules[currentFlow];
    };

    const getRightButtonAction = () => {
      const rules = {
        [FLOWS.WORDPRESS]: () => {
          wordpressSso();
          onboardingAnalytics.wordpressDefault.startNow();
          onboardingAnalytics.wordpressDefault.successContinue();
        },
        [FLOWS.WORDPRESS_IA]: () => {
          wordpressSso();
          onboardingAnalytics.wordpressIa.startNow();
          onboardingAnalytics.wordpressDefault.successContinue();
        },
        [FLOWS.SITE_BUILDER_V2]: () => {
          if (isAgentAvailableParam) {
            setCurrentStep(STEPS.AGENT_WELCOME);
            return;
          }
          setCurrentStep(STEPS.SITE_BUILDER_V2);
        },
        [FLOWS.SITE_BUILDER]: () => { siteBuilderSso(); onboardingAnalytics.sitebuilder.startNow(); },
        [FLOWS.OTHER_TOOLS]: () => otherToolsRedirect(),
      };

      return rules[currentFlow];
    };

    const getRightButtonLoading = () => {
      const rules = {
        [FLOWS.WORDPRESS]: sitesReducer.wordpressSso.loading,
        [FLOWS.WORDPRESS_IA]: sitesReducer.wordpressSso.loading,
        [FLOWS.SITE_BUILDER]: sitebuilderLoading,
        [FLOWS.SITE_BUILDER_V2]: sitebuilderLoading,
      };

      return rules[currentFlow];
    };

    const getRightButtonDisabled = () => {
      const rules = {
        [FLOWS.WORDPRESS]: sitesReducer.wordpressSso.loading,
        [FLOWS.WORDPRESS_IA]: sitesReducer.wordpressSso.loading,
        [FLOWS.SITE_BUILDER]: sitebuilderLoading,
      };

      return rules[currentFlow];
    };

    const testIdRules = {
      [FLOWS.WORDPRESS]: 'wp-normal',
      [FLOWS.WORDPRESS_IA]: 'wp-ai',
      [FLOWS.SITE_BUILDER]: 'sitebuilder',
    };

    const handleRedirectToPortal = () => {
      const analyticRules = {
        [FLOWS.WORDPRESS]: onboardingAnalytics.wordpressDefault.portalButton,
        [FLOWS.WORDPRESS_IA]: onboardingAnalytics.wordpressIa.portalButton,
        [FLOWS.SITE_BUILDER]: onboardingAnalytics.sitebuilder.portalButton,
      };

      const portalCta = analyticRules[currentFlow];
      portalCta && portalCta();
      onboardingAnalytics.wordpressDefault.successGoToPortal();

      if (otherToolsRedirect) {
        return otherToolsRedirect();
      }

      redirectToPortal();
    };

    return {
      imageSrc: getImage(),
      locales: getLocale(),
      buttonsProps: {
        leftButton: {
          testId: `${testIdRules[currentFlow]}-success-left-button`,
          label: onboardingLocale.wordPress.leftButtonLabel,
          onClick: handleRedirectToPortal,
        },
        rightButton: {
          testId: `${testIdRules[currentFlow]}-success-right-button`,
          label: onboardingLocale.wordPress.rightButtonLabel,
          iconRight: <IconArrow direction="right" />,
          onClick: getRightButtonAction(),
          loading: getRightButtonLoading(),
          disabled: getRightButtonDisabled(),
        },
      },
      cleanUp,
      blueSubtitle: currentFlow === FLOWS.SITE_BUILDER,
    };
  }, [
    usingTempDomain,
    onboardingLocale,
    sitesReducer.domainDnsChanged,
    sitesReducer.wordpressSso,
    dispatch,
    currentFlow,
    sitebuilderLoading,
    currentHosting,
    redirectToPortal,
    cleanUp,
    otherToolsRedirect,
    siteBuilderSso,
    setCurrentStep,
    isAgentAvailableParam,
  ]);

  const getUpgradePlanProps = useCallback(() => {
    const buttonsProps = {
      leftButton: {
        label: onboardingLocale.goBackButtonLabel,
        onClick: () => setCurrentStep(chooseDomainStep),
      },
      rightButton: {
        label: onboardingLocale.continueButtonLabel,
        iconRight: !wordpressLoading && <IconArrow direction="right" />,
        hostingId: selectedObject && selectedObject.hosting_id,
      },
    };

    return {
      locales: onboardingLocale.buyPlan,
      buttonsProps,
      hostingId: selectedObject && selectedObject.hosting_id,
    };
  }, [
    onboardingLocale,
    wordpressLoading,
    selectedObject,
    chooseDomainStep,
    setCurrentStep,
  ]);

  const getWordpressMigrationProps = useCallback(() => {
    const startedByAgent = migrationData.type === 'file' || migrationData.type === 'ftp';
    if (startedByAgent) {
      return {
        hostingId: migrationData.hostingId,
        domain: migrationData.domain,
        origin: 'ai_agents',
        migrationByAgentType: migrationData.type,
        exitMigrationFlow: () => setCurrentStep(STEPS.SELECT_DOMAIN),
        cleanUp,
      };
    }
    if (!currentHosting) {
      return {
        hostingId: selectedObject.hosting_id,
        domain: selectedObject.domain || selectedObject.selectedDomain,
        origin: 'wizard',
        exitMigrationFlow: () => setCurrentStep(STEPS.SELECT_DOMAIN),
        cleanUp,
      };
    }
    return {
      hostingId: currentHosting.hosting_id,
      domain: currentHosting.domain,
      exitMigrationFlow: () => setCurrentStep(STEPS.SELECT_DOMAIN),
      cleanUp,
      origin: 'wizard',
    };
  }, [currentHosting, selectedObject, migrationData, setCurrentStep, cleanUp]);

  const getDomainNotRegisteredProps = useCallback(() => {
    const domainInUse = (selectedObject && selectedObject.selectedDomain) || needRequestChangeDomain.newDomain;

    const handleBuyDomain = () => {
      const splitedOtherDomain = domainInUse.split('.');
      window.open(`${CART_URL}?pid=d&sld=${splitedOtherDomain[0]}&tld=.${splitedOtherDomain[1]}`, '_blank').focus();
      redirectToPortal();
    };

    const useTempDomain = () => {
      setUsingTempDomain(true);
      handleCreateTempDomain({ hostingId: undefined });
    };

    const backToChooseDomain = () => {
      setNeedRequestChangeDomain({ bool: false });
      dispatch(sitesActions.domainAvailability.set({}));
      setSelectedObject(null);
      setCurrentStep(chooseDomainStep);
    };

    const buttonsProps = {
      leftButton: {
        label: onboardingLocale.goBackButtonLabel,
        onClick: backToChooseDomain,
      },
      rightButton: [
        {
          label: onboardingLocale.useTempDomain,
          variant: 'tertiary',
          onClick: useTempDomain,
          disabled: domainsReducer.loadingTempDomainCreation || sitesReducer.loading,
          loading: domainsReducer.loadingTempDomainCreation || sitesReducer.loading,
        },
        {
          label: onboardingLocale.continueButtonLabel,
          iconRight: <IconExternalLink size="sm" color="highPure" secondaryColor="transparent" />,
          notFillSVG: true,
          onClick: handleBuyDomain,
        },
      ],
    };

    return {
      locales: onboardingLocale.domainNotRegistered,
      buttonsProps,
      domain: (selectedObject && selectedObject.selectedDomain) || needRequestChangeDomain.newDomain,
      currentFlow,
      FLOWS,
      hasMultDomainPlans: !!sitesReducer.list.filter(item => multiDomainsPlansIds.includes(item.package_id) && item.product_name && item.status === 'Active').length,
    };
  }, [
    onboardingLocale,
    selectedObject,
    chooseDomainStep,
    handleCreateTempDomain,
    domainsReducer.loadingTempDomainCreation,
    needRequestChangeDomain.newDomain,
    sitesReducer.loading,
    dispatch,
    redirectToPortal,
    setUsingTempDomain,
    setCurrentStep,
    currentFlow,
    sitesReducer.list,
  ]);

  const getExternalDomainProps = useCallback(() => {
    const goToSites = () => history.push(routesLocale.sites);
    const redirect = otherToolsRedirect || goToSites;

    let buttonsProps = {
      rightButton: {
        label: onboardingLocale.externalDomain.continueButtonLabel,
        iconRight: <IconArrow direction="right" />,
        onClick: redirect,
      },
    };

    const selectedObjectDomain = selectedObject && (selectedObject.domain || selectedObject.selectedDomain);
    const domain = currentHosting.domain || selectedObjectDomain;

    if (currentFlow === FLOWS.SITE_BUILDER) {
      buttonsProps = {
        leftButton: {
          label: onboardingLocale.externalDomain.continueButtonLabel,
          onClick: redirect,
          varian: 'secondary',
        },
        rightButton: {
          label: onboardingLocale.externalDomain.startNow,
          iconRight: <IconArrow direction="right" />,
          onClick: () => { siteBuilderSso(); },
          disabled: sitebuilderLoading,
          loading: sitebuilderLoading,
        },
      };
    }

    if (currentFlow === FLOWS.SITE_BUILDER_V2) {
      buttonsProps = {
        leftButton: {
          label: onboardingLocale.externalDomain.continueButtonLabel,
          onClick: redirect,
          varian: 'secondary',
        },
        rightButton: {
          label: onboardingLocale.externalDomain.startNow,
          iconRight: <IconArrow direction="right" />,
          onClick: () => {
            if (isAgentAvailableParam) {
              setCurrentStep(STEPS.AGENT_WELCOME);
              return;
            }
            setCurrentStep(STEPS.SITE_BUILDER_V2);
          },
          disabled: sitebuilderLoading,
          loading: sitebuilderLoading,
        },
      };
    }

    const locales = {
      ...onboardingLocale.externalDomain,
      title: onboardingLocale.externalDomain.title(domain),
    };

    const getImage = () => {
      const rules = {
        [FLOWS.WORDPRESS]: WpNormalScreen,
        [FLOWS.WORDPRESS_IA]: WpIaScreen,
        [FLOWS.SITE_BUILDER]: isBRServer ? siteBuilderSuccessBr : siteBuilderSuccessEs,
        [FLOWS.OTHER_TOOLS]: OtherToolsScreen,
      };

      return rules[currentFlow];
    };

    return {
      locales,
      buttonsProps,
      imageSrc: getImage(),
      cleanUp,
    };
  }, [
    currentHosting.domain,
    otherToolsRedirect,
    onboardingLocale,
    selectedObject,
    routesLocale.sites,
    currentFlow,
    history,
    cleanUp,
    siteBuilderSso,
    sitebuilderLoading,
    setCurrentStep,
    isAgentAvailableParam,
  ]);

  const exitConfirmModalProps = useCallback(() => ({
    onCloseModal: () => setDisplayExitConfirmModal(false),
    title: onboardingLocale.siteBuilderV2.exitConfirmModal.title,
    description: onboardingLocale.siteBuilderV2.exitConfirmModal.description,
    buttonsProps: [
      {
        variant: 'tertiary',
        label: onboardingLocale.siteBuilderV2.exitConfirmModal.exitButtonLabel,
        size: 'medium2',
        testId: 'button-exit-confirm',
        onClick: handleGoBack,
      },
      {
        variant: 'primary',
        label: onboardingLocale.siteBuilderV2.exitConfirmModal.cancelButtonLabel,
        size: 'medium2',
        testId: 'button-cancel',
        onClick: () => setDisplayExitConfirmModal(false),
      },
    ],
  }), [
    handleGoBack,
    onboardingLocale.siteBuilderV2.exitConfirmModal,
    setDisplayExitConfirmModal,
  ]);

  const advancedModeModalProps = useCallback(() => ({
    onCloseModal: () => setDisplayAdvancedModeModal(false),
    title: onboardingLocale.chooseSiteOption.advancedModeModal.title,
    description: onboardingLocale.chooseSiteOption.advancedModeModal.description,
    buttonsProps: [
      {
        variant: 'tertiary',
        label: onboardingLocale.chooseSiteOption.advancedModeModal.exitButtonLabel,
        size: isMobile ? 'small' : 'medium2',
        testId: 'button-exit-confirm',
        onClick: () => setDisplayAdvancedModeModal(false),
      },
      {
        variant: 'primary',
        label: onboardingLocale.chooseSiteOption.advancedModeModal.confirmButtonLabel,
        size: isMobile ? 'small' : 'medium2',
        testId: 'button-confirm',
        onClick: () => {
          handleRegisterHostingOnboarding();
          setCurrentFlow(FLOWS.OTHER_TOOLS);
          setCurrentStep(STEPS.SELECT_DOMAIN);
          setDisplayAdvancedModeModal(false);
        },
      },
    ],
  }), [
    onboardingLocale.chooseSiteOption.advancedModeModal,
    setCurrentFlow,
    setCurrentStep,
    isMobile,
    handleRegisterHostingOnboarding,
  ]);

  const normalModeModalProps = useCallback(() => ({
    onCloseModal: () => setDisplayNormalModeModal(false),
    title: onboardingLocale.chooseSiteOption.normalModeModal.title,
    description: onboardingLocale.chooseSiteOption.normalModeModal.description,
    buttonsProps: [
      {
        variant: 'tertiary',
        label: onboardingLocale.chooseSiteOption.normalModeModal.exitButtonLabel,
        size: isMobile ? 'small' : 'medium2',
        testId: 'button-exit-confirm',
        onClick: () => setDisplayNormalModeModal(false),
      },
      {
        variant: 'primary',
        label: onboardingLocale.chooseSiteOption.normalModeModal.confirmButtonLabel,
        size: isMobile ? 'small' : 'medium2',
        testId: 'button-confirm',
        onClick: () => {
          handleRegisterHostingOnboarding();
          setCurrentFlow(FLOWS.WORDPRESS);
          setCurrentStep(STEPS.SELECT_DOMAIN);
          setDisplayNormalModeModal(false);
        },
      },
    ],
  }), [
    onboardingLocale.chooseSiteOption.normalModeModal,
    setCurrentFlow,
    setCurrentStep,
    isMobile,
    handleRegisterHostingOnboarding,
  ]);

  const getChooseWpMigrationStep = useCallback(() => {
    const buttonsProps = {
      middleButton: {
        testId: 'toggleTempDomain',
        variant: 'tertiary',
        label: onboardingLocale.chooseWpMigrationStep.continueLater,
        onClick: () => {
          onCloseWizard({ handleGoBack });
          onboardingAnalytics.initialStep.doItLater();
          dispatchClmEvent({ action: 'click-create-site-or-migrate-wordpress-later', finished: true });
        },
      },
    };

    const options = [
      {
        ...onboardingLocale.chooseWpMigrationStep.options[0],
        cta: {
          ...onboardingLocale.chooseWpMigrationStep.options[0].cta,
          action: () => {
            setCurrentStep(STEPS.CHOOSE_SITE_OPTION);
            onboardingAnalytics.initialStep.chooseCreateSiteOption();
          },
        },
      },
      {
        ...onboardingLocale.chooseWpMigrationStep.options[1],
        cta: {
          ...onboardingLocale.chooseWpMigrationStep.options[1].cta,
          action: () => {
            setCurrentFlow(FLOWS.WORDPRESS_MIGRATION);
            onboardingAnalytics.initialStep.chooseMigrateSiteOption();
            setCurrentStep(STEPS.SELECT_DOMAIN);

            dispatch(onboardingActions.wizard.register.request({
              domain: currentHosting && currentHosting.domain,
              origin: 'wizard',
            }));
          },
        },
      },
    ];

    return {
      title: onboardingLocale.chooseWpMigrationStep.title,
      options,
      buttonsProps,
    };
  }, [
    onboardingLocale,
    currentHosting,
    dispatch,
    onCloseWizard,
    handleGoBack,
    setCurrentStep,
    setCurrentFlow,
    dispatchClmEvent,
  ]);

  const handleSyncPreviewWithAiBuilder = useCallback(() => {
    const currentBuilderAddonId = (currentHosting && currentHosting.builder_addon_id) ? currentHosting.builder_addon_id : null;
    const builderAddonIdByHostingId = getBuilderAddonIdByHostingId(currentHosting.hosting_id);
    const recentProvisionedBuilderAddonId = onboardingBuilderState.provisioning.builderAddonId;
    const builderAddonId = currentBuilderAddonId || builderAddonIdByHostingId || recentProvisionedBuilderAddonId;
    const selectedObjectDomain = currentHosting && currentHosting.domain;

    const requestProps = {
      builderAddonId,
      domain: selectedObjectDomain,
      isAgentFactory: isAgentAvailableParam,
      aiBuilderAgentData,
    };

    requestSyncPreviewWithAiBuilder({ ...requestProps });
  }, [
    aiBuilderAgentData,
    currentHosting,
    getBuilderAddonIdByHostingId,
    isAgentAvailableParam,
    onboardingBuilderState.provisioning.builderAddonId,
    requestSyncPreviewWithAiBuilder,
  ]);

  const handleCreateSiteWithAiBuilder = useCallback(({
    type,
    templateId = null,
    projectData = null,
  }) => {
    const selectedObjectDomain = currentHosting && currentHosting.domain;
    const currentBuilderAddonId = (currentHosting && currentHosting.builder_addon_id) ? currentHosting.builder_addon_id : null;
    const builderAddonIdByHostingId = getBuilderAddonIdByHostingId(currentHosting.hosting_id);
    const recentProvisionedBuilderAddonId = onboardingBuilderState.provisioning.builderAddonId;

    const createSiteWithAiBuilder = ({ builderAddonId }) => {
      updateOnboardingSteps(true);

      const requestProps = {
        builderAddonId,
        domain: selectedObjectDomain,
        type,
        isAgentFactory: isAgentAvailableParam,
        aiBuilderAgentData,
      };

      if (templateId) {
        requestProps.templateId = templateId;
      }

      if (projectData) {
        requestProps.projectData = projectData;
      }

      if (!onboardingHgBuilderPreview || templateId) {
        requestCreateSiteWithAiBuilder({ ...requestProps });
        return;
      }

      requestCreatePreviewWithAiBuilder({ ...requestProps });
    };

    if (currentBuilderAddonId || builderAddonIdByHostingId || recentProvisionedBuilderAddonId) {
      createSiteWithAiBuilder({ builderAddonId: currentBuilderAddonId || builderAddonIdByHostingId || recentProvisionedBuilderAddonId });
    } else {
      provisioningSitebuilderOnHosting({ hostingId: currentHosting.hosting_id, callback: createSiteWithAiBuilder });
    }
  }, [
    currentHosting,
    getBuilderAddonIdByHostingId,
    updateOnboardingSteps,
    requestCreateSiteWithAiBuilder,
    provisioningSitebuilderOnHosting,
    onboardingBuilderState.provisioning.builderAddonId,
    isAgentAvailableParam,
    aiBuilderAgentData,
    onboardingHgBuilderPreview,
    requestCreatePreviewWithAiBuilder,
  ]);

  useEffect(() => {
    if (userDomainsList.length === 1) {
      const getPackageId = userDomainsList[0].package_id;
      setCurrentHosting(prev => ({
        ...prev,
        package_id: getPackageId,
      }));
    }
  }, [userDomainsList, setCurrentHosting]);

  const getAiBuilderMyBusinessProps = useCallback(() => {
    const onContinue = ({ projectData: newProjectData }) => {
      siteBuilderAiAnalytics.clickCreateMySite();
      setProjectData(newProjectData);

      handleCreateSiteWithAiBuilder({ type: 'business-project', projectData: newProjectData });
    };

    const onGoBack = (isBackButtonTop = true) => {
      setCurrentStep(STEPS.SITE_BUILDER_V2);

      if (isBackButtonTop) {
        siteBuilderAiAnalytics.clickGoBackCreateWithMyBusiness();
        return;
      }

      siteBuilderAiAnalytics.clickGoBackChooseAnotherOption();
    };

    const onChangeInput = (value) => {
      dispatch(onboardingActions.sitebuilder.business.request(value));
    };

    return {
      locales: onboardingLocale.aiBuilderMyBusiness,
      onContinue,
      onGoBack,
      onChangeInput,
      redirectSuccessPageAiBuilder,
      businessList: onboardingBuilderState.business,
      builderProvisioningLoading: onboardingBuilderState.provisioning.loading,
      createSiteState: aiBuilderState.createSite,
      selectedObject,
      createPreviewLoading,
      createPreviewStatus,
      onboardingHgBuilderPreview,
      redirectPreviewPage,
    };
  }, [
    onboardingLocale.aiBuilderMyBusiness,
    onboardingBuilderState.provisioning.loading,
    setCurrentStep,
    aiBuilderState.createSite,
    onboardingBuilderState.business,
    selectedObject,
    dispatch,
    redirectSuccessPageAiBuilder,
    handleCreateSiteWithAiBuilder,
    createPreviewLoading,
    createPreviewStatus,
    onboardingHgBuilderPreview,
    redirectPreviewPage,
  ]);

  const getAiBuilderCreateSiteProps = useCallback(() => {
    const onContinue = ({ projectData: newProjectData }) => {
      setProjectData(newProjectData);
      handleCreateSiteWithAiBuilder({ type: 'ai-project', projectData: newProjectData });
    };

    const onGoBack = () => {
      setCurrentStep(STEPS.SITE_BUILDER_V2);
    };

    const trackingEventsByStep = {
      [CREATE_SITE_TABS.NAME]: () => { siteBuilderAiAnalytics.clickNextStepStep1(); },
      [CREATE_SITE_TABS.SEGMENT]: () => { siteBuilderAiAnalytics.clickNextStepStep2(); },
      [CREATE_SITE_TABS.INFOS]: () => { siteBuilderAiAnalytics.clickNextStepStep3(); },
    };

    return {
      createSiteState: aiBuilderState.createSite,
      builderProvisioningLoading: onboardingBuilderState.provisioning.loading,
      userCountry,
      onContinue,
      trackingEventsByStep,
      redirectSuccessPageAiBuilder,
      onGoBack,
      locales: onboardingLocale.aiBuilderCreateSite,
      createPreviewLoading,
      createPreviewStatus,
      onboardingHgBuilderPreview,
      redirectPreviewPage,
    };
  }, [
    onboardingLocale.aiBuilderCreateSite,
    onboardingBuilderState.provisioning.loading,
    userCountry,
    handleCreateSiteWithAiBuilder,
    aiBuilderState.createSite,
    redirectSuccessPageAiBuilder,
    setCurrentStep,
    createPreviewLoading,
    createPreviewStatus,
    onboardingHgBuilderPreview,
    redirectPreviewPage,
    setProjectData,
  ]);

  const getAiBuilderWithTemplateProps = useCallback(() => {
    const openTemplate = ({ templateId }) => {
      handleCreateSiteWithAiBuilder({ type: 'template-project', templateId });
    };

    const onGoBack = () => {
      setCurrentStep(STEPS.SITE_BUILDER_V2);
    };

    const trackingEvents = {
      clickCreateWithThisTemplate: () => { siteBuilderAiAnalytics.clickCreateWithThisTemplate(); },
      clickIWantThisTemplate: () => { siteBuilderAiAnalytics.clickIWantThisTemplate(); },
      clickSearchForAnother: () => { siteBuilderAiAnalytics.clickSearchForAnother(); },
      clickShowPreview: () => { siteBuilderAiAnalytics.clickShowPreview(); },
    };

    return {
      openTemplate,
      redirectSuccessPageAiBuilder,
      locales: onboardingLocale.aiBuilderWithTemplate,
      createSiteState: aiBuilderState.createSite,
      builderProvisioningLoading: onboardingBuilderState.provisioning.loading,
      createWithTemplatesState: onboardingBuilderState.createWithTemplates,
      getTemplateCategories: getBuilderTemplateCategories,
      getTemplates: getBuilderTemplates,
      onGoBack,
      trackingEvents,
    };
  }, [
    getBuilderTemplateCategories,
    getBuilderTemplates,
    aiBuilderState.createSite,
    onboardingLocale,
    redirectSuccessPageAiBuilder,
    handleCreateSiteWithAiBuilder,
    onboardingBuilderState.createWithTemplates,
    onboardingBuilderState.provisioning.loading,
    setCurrentStep,
  ]);

  const hasSelectedTool = !!otherToolsRedirect;

  useEffect(() => {
    if (migrationData.type) {
      setCurrentStep(STEPS.WORDPRESS_MIGRATION);
    }
  }, [migrationData, setCurrentStep]);

  useEffect(() => {
    if (isAgentAvailableParam && onboardingBuilderState.provisioning.status === 'failure' && currentStep === STEPS.IA_BUILDER_CREATE_SITE) {
      setCurrentStep(STEPS.SITE_BUILDER_V2);
    }
  }, [onboardingBuilderState.provisioning.status, currentStep, isAgentAvailableParam, setCurrentStep]);

  const getSiteBuilderV2Props = useCallback(() => {
    const cardsLocale = onboardingLocale.siteBuilderV2.cardsList;

    const onGoBack = () => {
      siteBuilderAiAnalytics.clickGoBackMethodSelection();
      setCurrentStep(STEPS.CHOOSE_WP_MIGRATION);
    };

    const cards = [
      {
        id: 'ia_builder_my_business',
        icon: <IconGoogleBusiness color="primaryBlue" size="lg" />,
        title: cardsLocale[STEPS.IA_BUILDER_MY_BUSINESS].title,
        desc: cardsLocale[STEPS.IA_BUILDER_MY_BUSINESS].desc,
        onClick: () => {
          setTypeProject('business-project');
          siteBuilderAiAnalytics.clickCreateWithMyBusiness();
          setCurrentStep(STEPS.IA_BUILDER_MY_BUSINESS);
        },
      },
      {
        id: 'ia_builder_create_site',
        icon: <IconAiStar color="primaryBlue" size="md" />,
        title: cardsLocale[STEPS.IA_BUILDER_CREATE_SITE].title,
        desc: cardsLocale[STEPS.IA_BUILDER_CREATE_SITE].desc,
        onClick: () => {
          if (isAgentAvailableParam) {
            handleCreateSiteWithAiBuilder({ type: 'ai-project', projectData });
          }
          setTypeProject('ai-project');
          siteBuilderAiAnalytics.clickCreateWithYourIdeas();
          setCurrentStep(STEPS.IA_BUILDER_CREATE_SITE);
        },
      },
      {
        id: 'ia_builder_with_template',
        icon: <IconPicture color="primaryBlue" size="md" />,
        title: cardsLocale[STEPS.IA_BUILDER_WITH_TEMPLATE].title,
        desc: cardsLocale[STEPS.IA_BUILDER_WITH_TEMPLATE].desc,
        onClick: () => {
          setTypeProject('template-project');
          siteBuilderAiAnalytics.clickCreateFromTemplate();
          setCurrentStep(STEPS.IA_BUILDER_WITH_TEMPLATE);
        },
      },
    ];

    return {
      siteBuilderV2Locale: onboardingLocale.siteBuilderV2,
      setCurrentFlow,
      cards,
      onGoBack,
      projectData,
      createSiteState: aiBuilderState.createSite,
      builderProvisioningLoading: onboardingBuilderState.provisioning.loading,
      locales: onboardingLocale.aiBuilderCreateSite,
      createPreviewLoading,
    };
  }, [
    onboardingLocale,
    setCurrentFlow,
    setCurrentStep,
    projectData,
    aiBuilderState.createSite,
    onboardingBuilderState.provisioning.loading,
    handleCreateSiteWithAiBuilder,
    isAgentAvailableParam,
    createPreviewLoading,
  ]);

  const getAiBuilderCreateSiteAgentProps = useCallback(() => {
    const onContinue = ({ projectData }) => {
      setProjectData(projectData);
      if (isAgentAvailableParam) {
        setCurrentStep(STEPS.AGENT_WELCOME);
      }
      setCurrentStep(STEPS.SITE_BUILDER_V2);
    };

    return {
      onContinue,
      createSiteState: aiBuilderState.createSite,
      builderProvisioningLoading: onboardingBuilderState.provisioning.loading,
      userCountry,
      locales: onboardingLocale.siteBuilderV2.aiBuilderCreateSiteAgent,
      setProjectData,
      projectData,
      aiBuilderAgentData,
      setAiBuilderAgentData,
    };
  }, [
    onboardingLocale.siteBuilderV2.aiBuilderCreateSiteAgent,
    userCountry,
    aiBuilderState.createSite,
    onboardingBuilderState.provisioning.loading,
    setCurrentStep,
    setProjectData,
    projectData,
    aiBuilderAgentData,
    setAiBuilderAgentData,
    isAgentAvailableParam,
  ]);

  const getSiteBuilderSuccessProps = useCallback(() => {
    const builderSsoState = sitesReducer.sitebuilder.sso;

    const popupBlockedAction = () => {
      setPopupBlockedModalOnCookie({ origin: POPUP_BLOCKED_ORIGIN.SITE_CREATED_WITH_HG_BUILDER });
    };

    const handleRequestBuilderSso = (() => {
      dispatch(sitesActions.builderSso.request({ builderAddonId: builderSsoState.builderAddonId, domain: builderSsoState.domain, popupBlockedAction }));
    });

    return {
      locales: onboardingLocale.siteBuilderV2.factoryAgent,
      loading: builderSsoState.loading,
      handleRequestBuilderSso,
      isMobile,
    };
  }, [
    dispatch,
    onboardingLocale,
    sitesReducer.sitebuilder,
    setPopupBlockedModalOnCookie,
    isMobile,
  ]);

  const onEditAgent = useCallback(() => {
    if (currentAgentId) {
      const editUrl = AGENT_FACTORY_URL_EDIT(currentAgentId);
      window.open(editUrl, '_blank');
    }
  }, [currentAgentId]);

  const onAgentSwitch = useCallback((status) => {
    if (currentAgentId) {
      dispatch(agentsFactoryActions.changeStatus.request({ status, agentId: currentAgentId }));
    }
  }, [dispatch, currentAgentId]);

  const getSiteBuilderAgentSuccessProps = useCallback(() => {
    const builderSsoState = sitesReducer.sitebuilder.sso;

    const popupBlockedAction = () => {
      setPopupBlockedModalOnCookie({ origin: POPUP_BLOCKED_ORIGIN.SITE_CREATED_WITH_HG_BUILDER });
    };

    const handleRequestBuilderSso = (() => {
      dispatch(sitesActions.builderSso.request({ builderAddonId: builderSsoState.builderAddonId, domain: builderSsoState.domain, popupBlockedAction }));
    });

    return {
      locales: onboardingLocale.sitebuilderAgentSuccess,
      loading: builderSsoState.loading,
      handleRequestBuilderSso,
      onEditAgent,
      onAgentSwitch,
    };
  }, [
    dispatch,
    onboardingLocale,
    sitesReducer.sitebuilder,
    setPopupBlockedModalOnCookie,
    onEditAgent,
    onAgentSwitch,
  ]);

  const getAgentWelcomeProps = useCallback(() => ({
    locales: onboardingLocale.agentWelcome,
    onContinue: () => {
      setCurrentFlow(FLOWS.AGENT_FACTORY);
      setCurrentStep(STEPS.IA_BUILDER_CREATE_SITE_AGENT);
    },
    agentWhatsAppEnabled,
  }), [onboardingLocale, setCurrentFlow, setCurrentStep, agentWhatsAppEnabled]);

  const getSiteBuilderPreviewProps = useCallback(() => {
    const handleGenerateNewSite = () => {
      handleCreateSiteWithAiBuilder({ type: typeProject, projectData });
    };

    return {
      locales: onboardingLocale.sitebuilderPreview,
      projectUid,
      createPreviewLoading,
      handleGenerateNewSite,
      handleSyncPreviewWithAiBuilder,
      builderProvisioningLoading: onboardingBuilderState.provisioning.loading,
      createSiteState: aiBuilderState.createSite,
      redirectSuccessPageAiBuilder,
    };
  }, [
    onboardingLocale,
    projectUid,
    createPreviewLoading,
    handleSyncPreviewWithAiBuilder,
    handleCreateSiteWithAiBuilder,
    projectData,
    onboardingBuilderState.provisioning.loading,
    aiBuilderState.createSite,
    redirectSuccessPageAiBuilder,
    typeProject,
  ]);

  const renderStep = {
    [STEPS.CHOOSE_WP_MIGRATION]: <ChooseWpMigrationStep {...getChooseWpMigrationStep()} />,
    [STEPS.CHOOSE_SITE_OPTION]: <ChooseSiteOption {...getChooseSiteOptionProps()} />,
    [STEPS.SELECT_DOMAIN]: <ChooseDomainStep {...getChooseDomainProps()} />,
    [STEPS.WORDPRESS_INSTALL]: <WordPressInstall {...getWordPressInstallProps()} />,
    [STEPS.SITE_ALREADY_EXISTS]: <SiteAlreadyExists {...getSiteAlreadyExistsProps()} />,
    [STEPS.SELECT_PLAN_LIST]: <SelectPlanListStep {...getSelectPlanListProps()} />,
    [STEPS.BUY_PLAN]: <UpgradePlanStep {...getUpgradePlanProps()} />,
    [STEPS.EXTERNAL_DOMAIN]: <ExternalDomain {...getExternalDomainProps()} />,
    [STEPS.BUY_DOMAIN]: <DomainNotRegistered {...getDomainNotRegisteredProps()} />,
    [STEPS.WORDPRESS_MIGRATION]: <WordpressMigration {...getWordpressMigrationProps()} />,
    [STEPS.IA_BUILDER_MY_BUSINESS]: <AiBuilderMyBusiness {...getAiBuilderMyBusinessProps()} />,
    [STEPS.IA_BUILDER_CREATE_SITE]: <AiBuilderCreateSite {...getAiBuilderCreateSiteProps()} />,
    [STEPS.IA_BUILDER_WITH_TEMPLATE]: <AiBuilderWithTemplate {...getAiBuilderWithTemplateProps()} />,
    [STEPS.SITE_BUILDER_V2]: <SiteBuilderV2 {...getSiteBuilderV2Props()} />,
    [STEPS.AGENT_WELCOME]: <AgentWelcome {...getAgentWelcomeProps()} />,
    [STEPS.IA_BUILDER_CREATE_SITE_AGENT]: <AiBuilderCreateSiteAgent {...getAiBuilderCreateSiteAgentProps()} />,
    [STEPS.SITE_BUILDER_PREVIEW]: <SiteBuilderPreview {...getSiteBuilderPreviewProps()} />,
    [STEPS.SUCCESS]: (() => {
      if (currentFlow === FLOWS.OTHER_TOOLS && !hasSelectedTool) {
        return <OtherToolsSuccess {...getSuccessOtherToolsProps()} />;
      }
      if (currentFlow === FLOWS.AGENT_FACTORY) {
        return <SiteBuilderSuccess {...getSiteBuilderSuccessProps()} />;
      }
      if (currentFlow === FLOWS.AGENT_FACTORY_ONBOARDING) {
        return <SiteBuilderAgentSuccess {...getSiteBuilderAgentSuccessProps()} />;
      }
      return <GenericSuccess {...getGenericSuccessProps()} />;
    })(),
  };

  if (!sitesOnboardingEnabled) {
    return (<Redirect to={routesLocale.home} />);
  }

  return (
    <>
      {(!!blockedWindowUrl) && (
        renderBlockedWindowModal({
          url: blockedWindowUrl,
          closeModal: handleCloseBlockedWindowModal,
          redirect: redirectToPortal,
        })
      )}

      {displayExitConfirmModal && <ExitConfirmModal {...exitConfirmModalProps()} />}
      {displayNormalModeModal && <ConfirmModal {...normalModeModalProps()} />}
      {displayAdvancedModeModal && <ConfirmModal {...advancedModeModalProps()} />}

      <Styles.SitesWizardHandlerWrapper $isInitialStep={initialStepStyle} $isLoading={isLoading}>
        <Styles.LogoRow>
          <Styles.BackWrapper>
            {currentStep === STEPS.CHOOSE_SITE_OPTION && (
              <IconButton
                testId="site-builder-v2-button-back"
                icon="IconArrow"
                color="lowDark"
                size="sm"
                onClick={() => onCloseWizard({ handleGoBack })}
              />
            )}
            <Styles.Logo $show={showLogo}>
              <HgLogoV2 newMenu />
            </Styles.Logo>
          </Styles.BackWrapper>
          {(!visibleAiChat && !minimizedChat) && (
            <Styles.NewAiWrapper>
              <Styles.ConversationBox $focused={aiButtonFocused}>
                <NewAiHeaderButton
                  overlayZIndex={0}
                  onFocusChange={setAiButtonFocused}
                />
              </Styles.ConversationBox>
            </Styles.NewAiWrapper>
          )}
          <IconButton
            testId="site-builder-v2-button-close"
            icon="IconClose"
            color="lowDark"
            size="sm"
            disabled={aiButtonFocused}
            onClick={() => {
              if (!aiButtonFocused) {
                handleCloseOnBoarding();
                dispatchClmEvent({ action: 'click-close-create-site', finished: true });
              }
            }}
          />
        </Styles.LogoRow>
        <Styles.Container $isLoading={isLoading}>
          {isLoading
            ? <Styles.IconLoadingWrapper><IconLoading /></Styles.IconLoadingWrapper>
            : renderStep[currentStep]
          }
        </Styles.Container>
      </Styles.SitesWizardHandlerWrapper>
    </>
  );
};

export default SitesWizardHandler;
